import type { IconName } from "@/components/ui/Icon";

export interface NavChild {
  label: string;
  to: string;
  desc: string;
  icon: IconName;
}

export interface NavItem {
  label: string;
  to: string;
  children?: NavChild[];
}

/** Single source of truth for the header, mobile menu and footer columns. */
export const NAV: NavItem[] = [
  { label: "Home", to: "/" },
  {
    label: "Projects",
    to: "/projects",
    children: [
      {
        label: "Completed Projects",
        to: "/projects",
        desc: "Case studies from contracted client work",
        icon: "award",
      },
      {
        label: "Turn-Key Projects",
        to: "/turnkey",
        desc: "Our own developments, available to buy",
        icon: "building",
      },
      {
        label: "Floor Plan Marketplace",
        to: "/floor-plans",
        desc: "Licence ready-to-build DWG plan sets",
        icon: "drafting",
      },
    ],
  },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Journal", to: "/journal" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_EXPLORE: { label: string; to: string }[] = [
  { label: "Completed Projects", to: "/projects" },
  { label: "Turn-Key Projects", to: "/turnkey" },
  { label: "Floor Plan Marketplace", to: "/floor-plans" },
  { label: "Services", to: "/services" },
  { label: "About Us", to: "/about" },
  { label: "Journal", to: "/journal" },
  { label: "Careers", to: "/careers" },
];

export const FOOTER_SERVICES: { label: string; to: string }[] = [
  { label: "Architecture", to: "/services/architecture" },
  { label: "Civil Engineering", to: "/services/civil-engineering" },
  { label: "Construction", to: "/services/construction" },
  { label: "Turn-Key Development", to: "/services/turnkey-development" },
  { label: "Project Management", to: "/services/project-management" },
  { label: "Consultancy", to: "/services/consultancy" },
];

export const SOCIALS: { icon: IconName; label: string; href: string }[] = [
  { icon: "linkedin", label: "LinkedIn", href: "#" },
  { icon: "instagram", label: "Instagram", href: "#" },
  { icon: "facebook", label: "Facebook", href: "#" },
  { icon: "youtube", label: "YouTube", href: "#" },
];
